// src/components/Header/navLinks.js

// Icons comune
import homeIcon from "../../assets/svg/material-symbols--home-outline-rounded.svg";
import calendarIcon from "../../assets/svg/mdi--calendar-outline.svg";
import calendarTextIcon from "../../assets/svg/mdi--calendar-text-outline.svg";
import addIcon from "../../assets/svg/mdi--calendar-plus-outline.svg";
import groupsIcon from "../../assets/svg/material-symbols--group-outline.svg";
import instrIcon from "../../assets/svg/mdi--account-cog-outline.svg";
import examIcon from "../../assets/svg/mdi--book-clock-outline.svg";
import categoriiIcon from "../../assets/svg/mdi--category-plus-outline.svg";
import videoIcon from "../../assets/svg/material-symbols--book-outline.svg";
import menuIcon from "../../assets/svg/material-symbols--menu-rounded.svg";
import reviewsIcon from "../../assets/svg/material-symbols--star-outline-rounded.svg";
import notificationIcon from "../../assets/svg/mingcute--notification-line.svg";
import messageIcon from "../../assets/svg/tabler--message.svg";
import enrollIcon from "../../assets/svg/material-symbols--group-add-outline.svg";
import backIcon from "../../assets/svg/material-symbols--arrow-back-rounded.svg";
import inboxIcon from "../../assets/svg/material-symbols--inbox-outline-rounded.svg";
import toolsIcon from "../../assets/svg/wrench.svg";

// Student
import testIcon from "../../assets/svg/material-symbols--book-outline.svg";
import examStudentIcon from "../../assets/svg/mdi--book-clock-outline.svg";
import practicalExamIcon from "../../assets/svg/material-symbols--car-tag-outline.svg";
import studentVideoIcon from "../../assets/svg/mdi--play-circle-outline.svg";

// Instructor

// Professor
import studentsIcon from "../../assets/svg/graduate.svg";
import { normalizeRole, ROLES } from "../../auth/access";
import {
   isExamInstructorProfile,
   isSuperiorInstructorType,
} from "../../constants/instructors";

function buildInstructorLinks(instructor) {
   const links = [
      { link: "/instructor", text: "Acasă", icon: homeIcon },
      {
         link: "/instructor/orarul-meu",
         text: "Orarul Meu",
         icon: calendarIcon,
      },
      { link: "/instructor/videoclipuri", text: "Video", icon: studentVideoIcon },
   ];

   if (isSuperiorInstructorType(instructor?.instructorType)) {
      links.push({
         link: "/instructor/orar-practice",
         text: "Orar practice",
         icon: calendarTextIcon,
      });
      // Aceleasi recenzii ca la manager, dar doar in citire.
      links.push({
         popup: "adminReviews",
         text: "Recenzii",
         icon: reviewsIcon,
         badgeKey: "adminReviews",
      });
   }

   if (isExamInstructorProfile(instructor)) {
      links.push({
         link: "/instructor/interne",
         text: "Orar interne",
         icon: calendarTextIcon,
      });
   }

   return links;
}

export function getLinksForRole(roleRaw, options = {}) {
   const role = normalizeRole(roleRaw);
   const instructor = options?.instructor || null;

   const map = {
      [ROLES.USER]: [
         { link: "/student", text: "Acasă", icon: homeIcon },
         { link: "/student/calendar", text: "Calendar", icon: calendarIcon },
         { popup: "staffChat", text: "Mesaje", icon: messageIcon, badgeKey: "staffChat" },
         { popup: "sAddProg", text: "Programare", icon: addIcon },
         { link: "/student/test", text: "Testare", icon: testIcon },
         { link: "/student/exam", text: "Ex. Teoretic", icon: examStudentIcon },
         { link: "/student/videoclipuri", text: "Video", icon: studentVideoIcon },
         {
            popup: "practicalExamBooking",
            text: "Ex. practic",
            icon: practicalExamIcon,
         },
         { popup: "studentReservations", text: "Rezervări", icon: calendarIcon },
         {
            popup: "notifications",
            text: "Notificări",
            icon: notificationIcon,
            badgeKey: "notifications",
         },
      ],

      [ROLES.INSTRUCTOR]: buildInstructorLinks(instructor),

      [ROLES.PROFESSOR]: [
         { link: "/professor", text: "Acasă", icon: homeIcon },
         { link: "/professor/students", text: "Studenți", icon: studentsIcon },
         { link: "/professor/testare", text: "Testare", icon: testIcon },
         { link: "/professor/groups", text: "Grupe", icon: groupsIcon },
      ],

      [ROLES.MANAGER]: [
         { link: "/manager", text: "Acasă", icon: homeIcon },
         //{
         //   link: "/manager/orar-max",
         //   text: "Lecții practice (MAX)",
         //   icon: calendarIcon,
         //},
         {
            link: "/manager/orar-extreme",
            text: "Lecții practice",
            icon: calendarIcon,
         },
         {
            link: "/manager/interne",
            text: "Examen practic",
            icon: calendarTextIcon,
         },
         {
            popup: "staffChat",
            text: "Mesaje",
            icon: messageIcon,
            badgeKey: "staffChat",
         },
         {
            link: "/manager/instructors",
            text: "Personal",
            icon: instrIcon,
         },
         // Ascuns: programarea nu mai depinde de grupele de instructori.
         // {
         //    link: "/manager/instr-groups",
         //    text: "Grupe instructori",
         //    icon: instrGroupsIcon,
         // },
         { popup: "startExam", text: "Examen teoretic", icon: examIcon },
         {
            popup: "adminReviews",
            text: "Recenzii",
            icon: reviewsIcon,
            badgeKey: "adminReviews",
         },
         {
            popup: "studentEnroll",
            text: "Înscriere",
            icon: enrollIcon,
         },
      ],

      [ROLES.ADMIN]: [
         { link: "/admin", text: "Acasă", icon: homeIcon },
         //{
         //   link: "/admin/orar-max",
         //   text: "Lecții practice (MAX)",
         //   icon: calendarIcon,
         //},
         {
            link: "/admin/orar-extreme",
            text: "Lecții practice",
            icon: calendarIcon,
         },
         {
            link: "/admin/interne",
            text: "Orar interne",
            icon: calendarTextIcon,
         },
         {
            popup: "staffChat",
            text: "Mesaje",
            icon: messageIcon,
            badgeKey: "staffChat",
         },
         {
            link: "/admin/instructors",
            text: "Personal",
            icon: instrIcon,
         },
         //{
         //   link: "/admin/bilete",
         //   text: "Import exam",
         //   icon: examIcon,
         //},
         //{
         //   link: "/chatbot",
         //   text: "Chatbot",
         //   icon: chatbotIcon,
         //},
         { popup: "startExam", text: "Examen teoretic", icon: examIcon },
         {
            popup: "adminReviews",
            text: "Recenzii",
            icon: reviewsIcon,
            badgeKey: "adminReviews",
         },
         {
            popup: "studentEnroll",
            text: "Înscriere",
            icon: enrollIcon,
         },
         // Deschide in loc meniul cu paginile rar folosite (vezi mai jos).
         { submenu: "more", text: "Altele", icon: menuIcon },
      ],
   };

   return map[role] || [];
}

/**
 * Paginile rar folosite: „Altele" din meniu nu deschide o pagină, ci
 * înlocuiește linkurile curente cu acestea; „Înapoi" revine la meniul
 * principal. Rolurile fără astfel de pagini primesc o listă goală.
 */
export function getMoreLinksForRole(roleRaw) {
   const role = normalizeRole(roleRaw);

   const map = {
      [ROLES.ADMIN]: [
         { back: true, text: "Înapoi", icon: backIcon },
         {
            popup: "questionCategories",
            text: "Categorii",
            icon: categoriiIcon,
         },
         {
            popup: "studentVideoLibrary",
            text: "Videoclipuri",
            icon: videoIcon,
         },
         {
            link: "/admin/mesaje-automate",
            text: "Mesaje automate",
            icon: notificationIcon,
         },
         { link: "/admin/inbox", text: "Inbox", icon: inboxIcon },
         {
            link: "/admin/corectare-teorie",
            text: "Corectare teorie",
            icon: examIcon,
         },
         {
            link: "/admin/corectare-exam",
            text: "Corectare examen",
            icon: examIcon,
         },
         { link: "/admin/altele", text: "Instrumente", icon: toolsIcon },
      ],
   };

   return map[role] || [];
}
